import { useCookies } from 'react-cookie'

import { useActionless, useAppSelector } from 'app-redux/hooks'

import { SET_ACTIVE_STATE } from 'app-redux/active/actions/types'

import UserService from 'services/user.service'

import GlobalOverlayStack from 'components/elements/Overlay/GlobalOverlayStack'
import TabContainer from 'components/elements/TabButtons'
import FollowedUsers from 'components/accountSettingsPage/FollowedUsers'

import Analytics from 'utils/googleAnalytics'

import styles from './followerFollowingOverlay.module.scss'

const FollowerFollowingOverlay = () => {
  const [{ tbId: userId }] = useCookies(['tbId'])

  const following = useAppSelector(state => state.active.modals.following)
  const followers = useAppSelector(state => state.active.modals.followers)

  const [setActiveState] = useActionless(SET_ACTIVE_STATE)

  const handleClose = () => setActiveState({ modals: { followers: false, following: false } })

  return (
    <GlobalOverlayStack
      open={following || followers}
      onClose={handleClose}
      className={styles.container}
      onOpen={() => Analytics.signalEvent('Follow overlay opened')}>
      <TabContainer
        className={styles.tabs}
        options={[
          {
            label: 'Users I follow',
            selected: following && !followers,
            onClick: () => setActiveState({ modals: { followers: false, following: true } }),
          },
          {
            label: 'Users who follow me',
            selected: !following && followers,
            onClick: () => setActiveState({ modals: { followers: true, following: false } }),
          },
        ]}
      />

      {following && !followers && (
        <FollowedUsers header="Following" fetchUsers={() => UserService.following(userId)} className={styles.users} />
      )}

      {!following && followers && (
        <FollowedUsers className={styles.users} header="Followers" fetchUsers={() => UserService.followers(userId)} />
      )}
    </GlobalOverlayStack>
  )
}

export default FollowerFollowingOverlay
